"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InternSurface = InternSurface;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _core = require("@focaltec-suite/core");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function InternSurface(_ref) {
  var tenantId = _ref.tenantId,
    routes = _ref.routes;
  var layoutContext = (0, _react.useContext)(_core.LayoutContext);
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    component: "main",
    sx: function sx(theme) {
      var props = {
        flexGrow: 1,
        marginTop: theme.spacing(8),
        marginBottom: theme.spacing(4),
        maxWidth: "calc(100vw - ".concat(layoutContext.drawer.width, "px)")
      };
      if (layoutContext.mobile) {
        var _transition = theme.transitions.create('margin', {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen
        });
        return Object.assign(Object.assign({}, props), {
          marginLeft: 0,
          transition: _transition
        });
      }
      var transition = theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      });
      return Object.assign(Object.assign({}, props), {
        marginLeft: "".concat(layoutContext.drawer.width, "px"),
        transition: transition
      });
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_core.AppRouter, {
    tenantId: tenantId,
    routes: routes
  }))));
}